import produce from 'immer';
import {
  EDIT_MARKETING_SEGMENTS_CUSTOMER_FAILED,
  EDIT_MARKETING_SEGMENTS_CUSTOMER_START,
  EDIT_MARKETING_SEGMENTS_CUSTOMER_SUCCESS,
  GET_EDITABLE_SEGMENTS_CUSTOMER_FAILED,
  GET_EDITABLE_SEGMENTS_CUSTOMER_START,
  GET_EDITABLE_SEGMENTS_CUSTOMER_SUCCESS,
  GET_MARKETING_SEGMENTS_CUSTOMERS_FAILED,
  GET_MARKETING_SEGMENTS_CUSTOMERS_START,
  GET_MARKETING_SEGMENTS_CUSTOMERS_SUCCESS
} from 'redux/actions/quote_marketing_segments';


const initialState = {
  marketingSegmentsCustomers: [],
  marketingSegmentsCustomersTotalCount: 0,
  editableMarketingSegmentsCustomer: null,
  isLoadingEditableMarketingSegmentsCustomer: false,
  isLoadingMarketingSegmentsCustomers: false,
  isLoadingEditCustomer: false
};

const formReducer = produce((state: IQuoteMarketingSegmentsState = initialState, action) => {
  switch (action.type) {
    case GET_MARKETING_SEGMENTS_CUSTOMERS_START: {
      state.isLoadingMarketingSegmentsCustomers = true;
      break;
    }
    case GET_MARKETING_SEGMENTS_CUSTOMERS_SUCCESS: {
      const { data: { customers } } = action;

      state.marketingSegmentsCustomers = customers.items;
      state.marketingSegmentsCustomersTotalCount = customers.total_count;
      state.isLoadingMarketingSegmentsCustomers = false;
      break;
    }
    case GET_MARKETING_SEGMENTS_CUSTOMERS_FAILED: {
      state.isLoadingMarketingSegmentsCustomers = false;
      break;
    }
    case GET_EDITABLE_SEGMENTS_CUSTOMER_START: {
      state.isLoadingEditableMarketingSegmentsCustomer = true;
      break;
    }
    case GET_EDITABLE_SEGMENTS_CUSTOMER_SUCCESS: {
      const { data: { customer } } = action;

      state.editableMarketingSegmentsCustomer = customer;
      state.isLoadingEditableMarketingSegmentsCustomer = false;
      break;
    }
    case GET_EDITABLE_SEGMENTS_CUSTOMER_FAILED: {
      state.isLoadingEditableMarketingSegmentsCustomer = false;
      break;
    }
    case EDIT_MARKETING_SEGMENTS_CUSTOMER_START: {
      state.isLoadingEditCustomer = true;
      break;
    }
    case EDIT_MARKETING_SEGMENTS_CUSTOMER_SUCCESS: {
      const {data: {customer}} = action;

      state.marketingSegmentsCustomers = state.marketingSegmentsCustomers.map((el) => el.id === customer.id ? customer : el);
      state.isLoadingEditCustomer = false;
      break;
    }
    case EDIT_MARKETING_SEGMENTS_CUSTOMER_FAILED: {
      state.isLoadingEditCustomer = false;
      break;
    }
    default:
      break;
  }
}, initialState);

export default formReducer;
